import React from 'react';
import buildUrl from 'build-url-ts';
import dateformat from 'dateformat';
import { Link } from 'react-router-dom';
import {Col } from 'react-bootstrap';
import ReadMoreTextView from 'src/legacy/components/ReadMoreTextView';
import Measure from "react-measure";
import DOMPurify from 'dompurify';
import ResponsiveHelper from "src/legacy/services/responsive.helper";


import { ToolBar, ToolBarGroup, ToolBarTabItem } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
// import ComposeContainer from 'src/components/ComposeView/ComposeContainer.jsx';


import AddToCollectionContainer from 'src/pages/asset/components/addCollection';
import { FileService } from 'src/services/file.service';
import userRoleService from 'src/services/userRoles.service';

import AssetDefaultIcon from "src/legacy/images/defaultAsset.jpg"

import cx from 'classnames';
import styles from './AssetDetailView.module.scss';
import _ from 'lodash';
import ViewMoreLess from 'src/legacy/components/ViewMoreLess';

import { localizedStrings } from 'src/localization';
import Slider from 'src/components/slider';
import ComposeDialog from 'src/components/compose/components/dialog';
import Text from 'src/components/text';

class AssetDetailView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expandCollection: false,
      expandStream: false,
      showShareAsset: false,
      showAddToCollection: false,
      showAll: false,
    }

    this.handleAssetClick = this.handleAssetClick.bind(this);
    this.handleRecordSearchClick = this.handleRecordSearchClick.bind(this);
    this.getFullName = this.getFullName.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSearch = localizedStrings.pages.search;
    this.localizedKeywords = localizedStrings.keywords;
  }

  componentDidMount() {
  }

  onSelectTagClicked(selectedTag) {

    var url = "/search/assets";

    var queryParams = {};
    queryParams['tags'] = selectedTag;

    url = buildUrl(url, {
      queryParams: queryParams
    });

    this.props.navigate(url);
    // browserHistory.push(url);
  }

  handleAssetClick(e) {
    const id = _.get(this.props,'asset.id') 
    this.props.recordSearchClick(id, "asset")

    this.context.recordAssetClicked({
      asset: this.props.asset.id,
      index: this.props.index
    });

  }
  

  _handleViewMoreClicked() {
    this.setState({
      showAll: true
    })
  }

  render() {
    var link = "";
    if(this.props.query){
      link = `/assets/${this.props.asset.id}?source=search?query=${this.props.query}`
    }else{
      link = `/assets/${this.props.asset.id}`;
    }

    const firstName = _.get(this.props, "details.createdBy.firstName")

    if (this.props.loading) {
      return (
        <div className={cx(styles.content, { [styles.customFieldApplied]: (this.props.customFields && this.props.customFields.length > 0) })}>
          <div className={styles.loading}>{ this.localizedSearch.asset.asset_detail_view.loading.details }...</div>
        </div>
      );
    }

    return (
      <div className={cx(styles.content, { [styles.customFieldApplied]: (this.props.customFields && this.props.customFields.length > 0) })} >
        <div className={styles.inner}>
          <Col md={10}>
            <h1 className={styles.name}> <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.asset.name)}}></div></h1>
            <div className={styles.metadataMetrics}>
              <div className={styles.metadataMetric}>
                {this.props.details.views} { this.localizedCommons.views }
              </div>
              <div className={styles.metadataDivider}>&nbsp;</div>
              {_.get(this.props, 'asset.metadata.content_length') > 0 &&  <div className={styles.metadataMetric}>
                {FileService.formatSize(_.get(this.props, 'asset.metadata.content_length'))}
              </div>
              }
              <div className={styles.metadataDivider}>&nbsp;</div>
              <div className={styles.metadataMetric}>
                {FileService.getFileType(this.props.asset.metadata)}
              </div>
              <div className={styles.metadataDivider}>&nbsp;</div>
              <div className={styles.metadataMetric}>
                { this.localizedCommons.last_viewed } : {dateformat(this.props.details.lastReadDate, 'dd mmm yyyy')}
              </div>
            </div>
            <div className={cx(styles.metrics, styles.noMargin)}>
              <div className={styles.metric}>
                {_.size(firstName) > 0 && (
                  <>
                    {`${this.localizedCommons.created_by} :`}
                    <Text text={this.getFullName()} lines={1} className={styles.createdBy} />
                  </>
                )}
              </div>
              {_.get(this.props, "details.uploadedDate") && (
                <>
                  <div className={styles.divider}>&nbsp;</div>
                  <div className={styles.metric}>
                    {this.localizedCommons.created_on} :{" "}
                    {dateformat(
                      _.get(this.props, "details.uploadedDate"),
                      "dd mmm yyyy",
                    )}
                  </div>
                </>
              )}
            </div>
            <Col md={12} className={cx(styles.noPadding,styles.metaDataContainer)}>
              <Col md={7} className={styles.noPadding}>
                <Measure bounds
                  onResize={(contentRect) => {
                    let tagHeight = contentRect.bounds.height + 180;
                    this.props.height(tagHeight);
                  }}>

                  {({ measureRef }) =>
                    <div ref={measureRef} className={styles.description}>
                      {_.get(this.props, "asset.summary") && <ViewMoreLess isFromAsset={true}>
                        <div id="templateContent" className={cx(styles.descriptionContainer, "viewMoreLess")} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(_.get(this.props, "asset.summary"), { ADD_TAGS: ["iframe"], ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'scrolling'] }) }}></div>
                      </ViewMoreLess>}
                      {this.props.asset.tags &&
                        <div className={styles.tags}>
                          <span className={styles.tagsHeading}>{ this.localizedSearch.asset.asset_detail_view.tags}:</span>
                          {this.renderTags()}
                        </div>
                      }
                    </div>
                  }
                </Measure>
                {this._renderActionGroup(this.props.asset, link)}
              </Col>
              <Col md={4} className={cx(styles.noPadding)}>
                {this._renderAvailableSection()}
              </Col>
            </Col>
          </Col>
          <Col md={2} className={styles.noPadding}>
            <div className={styles.icon}>{this.renderAssetIcon(link)}</div>
          </Col>
        </div>

        <ComposeDialog
          sourceType="Share Asset"
          show={this.state.showShareAsset}
          dialog={true}
          initialContent={[this.props.asset]}
          onFinish={() => {
            this.setState({
              showShareAsset: false,
            });
          }}
          onClose={() => {
            this.setState({
              showShareAsset: false,
            });
          }}
        />

        <Slider.Dialog width={"380px"} show={this.state.showAddToCollection}>
          <AddToCollectionContainer
            show={this.state.showAddToCollection}
            assets={[this.props.asset]}
            searchAssets={_.get(this.props, "asset", [])}
            sourceType="Search"
            onClose={() => {
              this.setState({ showAddToCollection: false });
            }}
          />
        </Slider.Dialog>
      </div>
    );
  }

  renderTags() {

    var optionsToShow = 12;
    var shouldCollapse = this.props.asset.tags.length > optionsToShow && !this.state.showAll;

    var tags = this.props.asset.tags;

    if (shouldCollapse) {
      tags = tags.slice(0, optionsToShow);
    }

    let items = tags.map((tag, index) => {
      return (
        <div
          key={index}
          className={cx(styles.tag)}
          onClick={this.onSelectTagClicked.bind(this, tag)}>
          { <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`#${tag},`)}}></div>}
        </div>
      );
    })

    if (shouldCollapse) {
      items.push(
        <div
          className={cx(styles.tag, styles.more)}
          onClick={this._handleViewMoreClicked.bind(this)}>
          { this.localizedCommons.actions.view_more }...
        </div>
      );
    }

    return items;
  }

  renderAssetIcon(link) {
    const asset = this.props.asset;
    var icon = AssetDefaultIcon;
    if (asset.icon) {
      icon = asset.icon.thumbnail;
    }

    return (
      <Link to={link} onClick={this.handleAssetClick}>
        <img src={icon} />
      </Link>
      );
  }

  _renderActionGroup(asset, link) {
    return (
      <ToolBar className={styles.toolbar}>
        <ToolBarGroup className={styles.item}>
          <ToolBarButtonItem className={cx(styles.action, styles.viewAction)} width="auto" height="auto">
            <Link  to={link} className={styles.assetLink} >
              <div className={cx(styles.link)}
              onClick={this.handleRecordSearchClick}>
                <span className={cx(styles.actionIcon, "paperflite-right-arrow")} />{ this.localizedSearch.asset.asset_detail_view.actions.view }
              </div>
            </Link>
          </ToolBarButtonItem>
          {asset.settings && asset.settings.share && userRoleService.canShare() && 
            <ToolBarButtonItem className={cx(styles.action, styles.shareAction)}
              width="auto" height="auto"
              onClick={() => this.onShareAssetClicked()}>
              <div className={cx(styles.link)}>
                <span className={cx(styles.actionIcon, "paperflite-share")} />{ this.localizedSearch.asset.asset_detail_view.actions.share }
              </div>
            </ToolBarButtonItem>
          }
          {userRoleService.canAccessCollection() &&
          <ToolBarButtonItem className={cx(styles.action, styles.addAction)}
            width="auto" height="auto"
            onClick={() => this.onAddToMyCollectionClicked()}>
            <div className={cx(styles.link)}>
              <span className={cx(styles.actionIcon, "paperflite-plus")} />{ this.localizedSearch.asset.asset_detail_view.actions.add_to_my_collection }
            </div>
          </ToolBarButtonItem>
          }
        </ToolBarGroup>
      </ToolBar>
    );
  }

  renderDescription() {
    if (!this.props.asset.summary) {
      return false;
    }
    
    return <ReadMoreTextView lines={3} more={false}>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.asset.summary)}}></div>
    </ReadMoreTextView>;
  }

  getFullName() {
      const firstName = _.get(this.props, "details.createdBy.firstName", "");
      const lastName = _.get(this.props, "details.createdBy.lastName", "");
      return `${firstName}${lastName ? ` ${lastName}` : ""}`;
    }
  

  _renderAvailableSection() {
    var streams = this.props.details.streams;
    var collections = this.props.details.collections;

    var access;

    if (_.size(streams) == 0 && _.size(collections) == 0) {
      return false;
    }

    if (_.size(collections) > 0 && userRoleService.canAccessCollection() || _.size(streams) > 0 && userRoleService.canAccessHub()) {
      access = true;
    } else {
      return false;
    }

    return (
      <div className={styles.availableSection}>
       {access && <h4>{ this.localizedSearch.asset.asset_detail_view.available_in }</h4>}
        <div className={styles.scrollContainer}>
          {userRoleService.canAccessHub() && streams.length > 0 &&
            <div className={cx(styles.entity, { [styles.expand]: this.state.expandStream })}>
              <div className={styles.header} onClick={() => {
                this.setState({
                  expandStream: !this.state.expandStream
                });
              }}>
                <i className={cx(styles.toggleIcon, {
                  'paperflite-plus': !this.state.expandStream,
                  'paperflite-minus': this.state.expandStream
                })}></i>
                {`${streams.length} ${streams.length > 1 ? this.localizedKeywords.streams : this.localizedKeywords.stream}`}
              </div>
              <ul className={cx(styles.body)}>
                {this._renderStreams(streams)}
              </ul>
            </div>
          }

          {userRoleService.canAccessCollection () && collections.length > 0 &&
            <div className={cx(styles.entity, { [styles.expand]: this.state.expandCollection })}>
              <div className={styles.header} onClick={() => {
                this.setState({
                  expandCollection: !this.state.expandCollection
                });
              }}>
                <i className={cx({
                  'paperflite-plus': !this.state.expandCollection,
                  'fa-solid fa-minus': this.state.expandCollection
                })}></i>
                {`${collections.length} ${collections.length > 1 ? this.localizedKeywords.collections : this.localizedKeywords.collection }`}
              </div>
              <ul className={cx(styles.body, { [styles.expand]: this.state.expandCollection })}>
                {this._renderCollections(collections)}
              </ul>
            </div>
          }
        </div>
      </div>
    );
  }

  _renderStreams(streams) {
    return streams.map(stream => {
      return (
        <li className={cx(styles.item, styles.stream)}>
          <Link to={`/streams/${stream.id}`} className={styles.link}>
            <span className={cx('fa', styles.indicator, styles.active)}></span>
            <span className={cx('fa', 'fa-newspaper')}></span>
            <span className={styles.name}><Text text={stream.name} /></span>
          </Link>
        </li>
      );
    });
  }

  _renderCollections(collections) {
    return collections.map(collection => {
      return (
        <li className={cx(styles.item, styles.collection)}>
          <Link to={`/collections/${collection.id}`} className={styles.link}>
            <span className={cx('fa', styles.indicator, styles.active)}></span>
            <span className={cx('fa', 'fa-newspaper')}></span>
            <span className={styles.name}><Text text={collection.name} /></span>
          </Link>
        </li>
      );
    });
  }

  onAddToMyCollectionClicked() {
    this.props.invalidateCollectionsSelection();
    var fileType = FileService.getFileType(_.get(this.props, "asset.metadata"));
    this.props.trackAdoptionMetricsForAddToCollectionClickedEvent(fileType);
    this.setState({
      showAddToCollection: true
    })
  }

  onShareAssetClicked() {
    this.props.selectAsset(this.props.asset);
    this.setState({
      showShareAsset: true
    })
  }

  handleRecordSearchClick(e){
  const id = _.get(this.props,'asset.id')
  this.props.recordSearchClick(id, "asset")
  }
}

export default AssetDetailView;    
